module.exports = __webpack_public_path__ + "img/中信银行.af7b41ac.png";